import { render, staticRenderFns } from "./ShippingTruckSvg.vue?vue&type=template&id=4cab1a9e"
import script from "./ShippingTruckSvg.vue?vue&type=script&lang=js"
export * from "./ShippingTruckSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports